import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Snackbar, Tab, Tabs } from "@mui/material";
import { style as modalstyle } from "../../../components/Loading/Loading";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { defaultValues, schema } from "./Validacoes";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR/";
import styles from "./Cadastro.module.css";
import servSolicitacaoVistoria from "../../../services/login/servSolicitacaoVistoria";
import servParam from "../../../services/login/servParam";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { Geral } from "./Abas/Geral";
import { Documentos } from "./Abas/Documentos";
import { ErrorHandling } from "../../../components/Errors/Errors";
import { logout } from "../../../state/slices/userSlice";
import servAnalises from "../../../services/login/servAnalises";
import servSolicitacaoAcesso from "../../../services/login/servSolicitacaoAcesso";
import { maskUC } from "../../../infra/utils/maskUC";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Cadastro = ({
    pesquisar,
    recordForEdit,
    setOpen,
    novoCadastro,
    setEhNovoCadastro
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const methods = useForm({ defaultValues: defaultValues, resolver: yupResolver(schema) });
    const user = useSelector(state => state.user);
    const solicAcesso = methods.watch("SolicitacaoDeAcesso");
    const ucState = useSelector(state => state.uc);

    const [tabIndex, setTabIndex] = useState(0);
    const [podeSalvar, setPodeSalvar] = useState(true);

    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [typeAlert, setTypeAlert] = useState("error");
    const [isLoading, setIsLoading] = useState(false);

    const [solicitacaoAcesso, setSolicitacaoAcesso] = useState(null);
    const [uc, setUc] = useState(null);
    const [analiseSolic, setAnaliseSolic] = useState(null);
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        const recuperarAsolicAcesso = async () => {
            try {
                setIsLoading(true);

                const data = await servAnalises.RecuperarUltimaAnaliseAcesso(solicAcesso.value);

                data.Content && setAnaliseSolic(data.Content[0]);

                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
            }
        }

        const recuperarSolicAcessoParaSetarUc = async () => {
            try {
                setIsLoading(true);

                const data = await servSolicitacaoAcesso.RecuperarParaEditar(solicAcesso.value);

                setSolicitacaoAcesso(data?.Content);
                setUc(data?.Content?.CodigoUC);

                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
            }
        }


        if (solicAcesso.value !== '') {
            recuperarAsolicAcesso();
            recuperarSolicAcessoParaSetarUc();
        }
    }, [solicAcesso]);

    useEffect(() => {
        const situacoesBloqueadas = [1, 3, 4, 5];

        const recuperarDadosParaEdicao = async () => {
            try {

                setIsLoading(true);

                const data = await servSolicitacaoVistoria.RecuperarParaEditar(recordForEdit.Id);

                mapearRetorno(data.Content);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.request?.status,
                    err?.message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const recuperarDocumentosIniciais = async () => {
            try {
                setIsLoading(true);

                let response = await servParam.RecuperarDocumentosObrigatorios(4);

                setDocumentosObrigatorios(response.Content);

                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);

                setTypeAlert("error");

                return ErrorHandling(
                    err?.request?.status,
                    err?.message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const setarDataDeConclusaoDefault = () => {
            let dataInicial = new Date();

            dataInicial.setHours(0);
            dataInicial.setMinutes(0);
            dataInicial.setSeconds(0);
            dataInicial.setMilliseconds(0);

            methods.setValue("DataConclusaoInstalacaoGD", dataInicial);
        }

        if (novoCadastro === false) {
            if (recordForEdit === null) return;
            recuperarDadosParaEdicao();

            if (situacoesBloqueadas.includes(recordForEdit.Situacao)) {
                setPodeSalvar(false);
            }
        } else {
            setarDataDeConclusaoDefault();
            recuperarDocumentosIniciais();
        }
    }, [recordForEdit]);

    const mapearRetorno = (data) => {
        let uc = data?.SolicitacaoDeAcessoDTO?.CodigoUc;
        let labelUc;

        if (!uc) {
            labelUc = 'Não informado';
        } else {
            labelUc = ucState?.rn1095 ? maskUC(String(uc)) : uc;
        }

        methods.setValue("Id", data.CodigoSolicitacaoVistoria || data.Id);
        methods.setValue("Situacao", data.Situacao);
        methods.setValue("Protocolo", data.Protocolo);
        methods.setValue("Observacao", data.Observacao);
        methods.setValue("DataCadastro", data.DataCadastro);
        methods.setValue("PrazoAnalise", data.PrazoAnalise);
        methods.setValue('DataConclusaoInstalacaoGD', parse(data.DataConclusaoInstalacaoGD, 'dd/MM/yyyy HH:mm:ss', new Date()));

        data.SolicitacaoDeAcessoDTO && methods.setValue("SolicitacaoDeAcesso", {
            value: data.CodigoSolicitacaoAcesso,
            label: data.CodigoSolicitacaoAcesso
                + ` - ${data.SolicitacaoDeAcessoDTO.Nome}`
                + (data.SolicitacaoDeAcessoDTO.Situacao === 1
                    ? ` - Aguardando análise`
                    : data.SolicitacaoDeAcessoDTO.Situacao === 2
                        ? ` - Revisar Solicitação`
                        : data.SolicitacaoDeAcessoDTO.Situacao === 4
                            ? ` - Análise Aprovada`
                            : ` - Análise arquivada`)
                + ` - UC: ${labelUc}`
        });

        data.SolicitacaoDeAcessoDTO && setUc(data.SolicitacaoDeAcessoDTO.CodigoUc);

        let docs = data.DocumentosObrigatorios;

        if (!docs) return;

        docs.map((doc) => {
            if (data.Documentos.length) {
                for (let i = 0; i < data.Documentos.length; i++) {
                    if ((doc.Id == data.Documentos[i].CodigoConfigDoc)
                        && (doc.CodigoClassificacaoDoc == data.Documentos[i].CodigoClassificacoDoc)) {
                        doc.CodigoDocumento = data.Documentos[i].CodigoDocumento;
                        doc.NomeArquivo = data.Documentos[i].NomeArquivo;
                    }
                }
            }
        });

        setDocumentosObrigatorios(docs);
    }

    const handleCadastroSolicAcesso = methods.handleSubmit(async (data) => {
        try {

            if (data.Id === 0) {
                setIsLoading(true);

                data.CodigoSolicitacaoAcesso = data?.SolicitacaoDeAcesso.value;
                data.CodigoResponsavelTecnico = user.codigoUsuario;

                const response = await servSolicitacaoVistoria.Inserir(data);

                mapearRetorno(response.Content);
                methods.reset({}, { keepValues: true });

                setTypeAlert("success");
                setOpenError(true);
                setErrorMessage("Dados salvos com sucesso")

                pesquisar();

                setIsLoading(false);
            } else {
                setIsLoading(true);

                data.CodigoSolicitacaoAcesso = data?.SolicitacaoDeAcesso.value;
                data.CodigoResponsavelTecnico = user.codigoUsuario;

                data.CodigoSolicitacaoVistoria = data.Id;

                const response = await servSolicitacaoVistoria.Editar(data);

                mapearRetorno(response.Content);
                methods.reset({}, { keepValues: true });

                setTypeAlert("success");
                setOpenError(true);
                setErrorMessage("Dados alterados com sucesso")

                pesquisar();

                setIsLoading(false);
            }

        } catch (err) {
            setIsLoading(false);

            setTypeAlert("error");

            return ErrorHandling(
                err?.request?.status,
                err?.message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message
            );
        }
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const handleTabChange = async (event, newValue) => {
        const situacoesNaoEditaveis = [1, 3, 4, 5];

        if (situacoesNaoEditaveis.includes(methods.getValues("Situacao"))) {
            setTabIndex(newValue);
            return;
        }

        if (methods.getValues("Id") == 0) {
            if (methods.getValues("SolicitacaoDeAcesso.value") == "") {
                setErrorMessage("É necessário informar um orçamento de conexão para avançar.");
                return setOpenError(true);
            }

            await handleCadastroSolicAcesso();

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            setTabIndex(newValue);
        } else {
            let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

            if (houveAlteracaoCampos) {
                await handleCadastroSolicAcesso();

                if (Object.keys(methods.formState.errors).length > 0) {
                    return;
                }
            }

            setTabIndex(newValue);
        }
    }

    const fecharJanela = () => {
        setEhNovoCadastro(false);
        setOpen(false);
    }

    const handleClickOpenDialog = async (event, reason) => {
        try {
            await handleCadastroSolicAcesso();

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            if (reason === 'clickaway') {
                setOpenDialog(true);
            }

            setOpenDialog(true);
        } catch (err) {
            setOpenDialog(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    }

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }

        setOpenDialog(false);
    }

    const solicitarHomologacao = async () => {
        try {
            setIsLoading(true);

            await servAnalises.EnviarVistoriaParaAnalise(methods.getValues("Id"));

            setOpenError(true);
            setErrorMessage("Solicitação de análise enviada com sucesso.");
            setIsLoading(false);

            setOpenDialog(false);

            setTimeout(() => {
                setOpen(false);
                pesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setOpenDialog(false);
            setOpenError(true);
            setTypeAlert("error");

            setErrorMessage(err?.response?.data?.Message);
            return setOpen(true);
        }
    }

    return (
        <div className={styles['modal-main']}>
            {methods.getValues("Id") !== 0 && (
                <div>
                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={styles.dateBox}></div><b>Data de início:</b> {
                                format(parse(methods.getValues("DataCadastro"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                    locale: ptBR
                                })
                            }
                        </span>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data prazo:</b>
                            {
                                methods.getValues("PrazoAnalise") && (methods.getValues("PrazoAnalise").includes("01/01/1900") || methods.getValues("PrazoAnalise").includes("01/01/0001")) ?
                                    "Data ainda não definida" :
                                    format(parse(methods.getValues("PrazoAnalise"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-darkblue']}`}></div><b>Orç. de conexão: </b> {solicAcesso.value}
                        </span>

                        {methods.getValues("Protocolo") && (
                            <span className={styles.headerData}>
                                <div className={`${styles.dateBox} ${styles['dateBox-gray']}`}></div><b>Protocolo: </b> {methods.getValues("Protocolo")}
                            </span>
                        )}
                    </header>
                </div>
            )}

            <FormProvider {...methods} >
                <form onSubmit={handleCadastroSolicAcesso}>
                    <div className={styles.class100}>
                        <div className={styles.tabsHeader}>
                            <Tabs value={tabIndex} sx={{ width: "95%" }} onChange={handleTabChange} aria-label="abas cadastro de solicitação">
                                <Tab sx={{ color: "whitesmoke" }} label="Geral" {...a11yProps(0)} />
                                <Tab sx={{ color: "whitesmoke" }} label="Documentos" {...a11yProps(1)} />
                            </Tabs>
                        </div>
                        <TabPanel value={tabIndex} index={0}>
                            <Geral
                                aprovado={2}
                                analise={analiseSolic}
                                situacao={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                uc={uc}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Documentos
                                codigoSolicitacao={methods.getValues('Id')}
                                documentos={documentosObrigatorios}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                podeFazerUpload={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                setIsLoading={setIsLoading}
                                tipoRamal={solicitacaoAcesso?.TipoRamal}
                                classificacaoGeracao={solicitacaoAcesso?.ClassificacaoGeracao}
                                setTypeAlert={setTypeAlert}
                            />
                        </TabPanel>
                    </div>
                    <div className={styles['solicitacao-botoes']}>
                        <BlueHoverButton type="submit" disabled={!podeSalvar}>Salvar</BlueHoverButton>
                        {tabIndex == 1 && (
                            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>
                                Solicitar análise
                            </BlueHoverButton>
                        )}
                        <BlueHoverButton onClick={fecharJanela}>Cancelar</BlueHoverButton>
                    </div>
                </form>
            </FormProvider>

            <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose} >
                <Alert onClose={handleClose} severity={typeAlert} sx={{ width: "100%" }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalstyle}>
                    <CircularProgress />
                </Box>
            </Modal>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: "#232323", fontWeight: "bold" }}>
                    {"Solicitar análise"}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#232323" }}>
                    <DialogContentText id="alert-dialog-description" sx={{ color: "whitesmoke" }}>
                        Você deseja solicitar a análise da solicitação de vistoria?
                        Após a solicitação, o registro só poderá ser alterado em uma eventual reprovação.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ backgroundColor: "#232323" }}>
                    <BlueHoverButton onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    <BlueHoverButton autoFocus onClick={solicitarHomologacao}>
                        Continuar
                    </BlueHoverButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export { Cadastro }